module.exports = __webpack_public_path__ + "static/ellis-brigham-skin-4c061eb263e704065cf9f934bf038665.jpg";